module.exports = __webpack_public_path__ + "static/screen-inside-4-67e5c8baf3fe1ecc2b87345d08748208.jpg";